export default __webpack_public_path__ + "static/media/email.86c660a3.png";